import React, { useState } from "react";
import "./Footer.css";
import mayuuu from "../../assets/images/Untitled-1.png";
import main_logo from "../../assets/images/Maya-VerticalLockup.png";
import { Link } from "react-router-dom";

const Footer = () => {
      const [activeIndex, setActiveIndex] = useState(null);
       
      const toggleHelp = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
      };

  return (
    <div className="div_container">
      <div>
        <div className="footer_part">
          <div className="call_me">
            <p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="25px"
                viewBox="0 -960 960 960"
                width="25px"
                fill="#5f6368"
              >
                <path d="M243-401.5h308.5V-459H243v57.5Zm0-129h474V-588H243v57.5Zm0-129h474V-717H243v57.5ZM85-87.5V-818q0-22.97 17.27-40.23 17.26-17.27 40.23-17.27h675q22.97 0 40.23 17.27Q875-840.97 875-818v516q0 22.97-17.27 40.23-17.26 17.27-40.23 17.27H242L85-87.5ZM217.5-302h600v-516h-675v597l75-81Zm-75 0v-516 516Z" />
              </svg>
            </p>
            <p> Need Help?&nbsp; </p>
            <p className="chat__with__us">
              {" "}
              <a href="https://www.instagram.com/mayawears.np/"> Chat with us</a>
            </p>
          </div>
          {/* <div className="new__logo">
            <img src={mayuuu} alt="" />
          </div> */}
          {/* <div className="footer_menu container">
            <div className={`faq-item ${activeIndex === 0 ? "active" : ""}`} onClick={() => toggleHelp(0)} >
              <div className="faq-question"><h3>Contact Us</h3> </div>
              <div className="faq-answer help_answer">
                <p><a href="tel:9849531357">Contact Us</a></p>
                <p><a href="https://www.instagram.com/mayawears.np/?hl=en" target="_blank" rel="noopener noreferrer">Instagram</a></p>
                <p><a href="https://wa.me/9766549770" target="_blank" rel="noopener noreferrer">WhatsApp</a></p>
              </div>
            </div>
          <div className={`faq-item ${activeIndex === 1 ? "active" : ""}`}  onClick={() => toggleHelp(1)} >
            <div className="faq-question"><h3>Services</h3> </div>
            <div className="faq-answer">
              <p>World Wide Delivery</p>
              <p>Easy Exchange</p>
            </div>
          </div>
          <div className={`faq-item ${activeIndex === 2 ? "active" : ""}`} onClick={() => toggleHelp(2)}>
            <div className="faq-question"> <h3>About Maya</h3> </div>
            <div className="faq-answer help_answer">
              <Link to="/about_us"><p>About Maya </p></Link>
            </div>
            </div>
          </div> */}
          <div className="lo__go">
            <Link to="/">
              <img src={main_logo} alt="" />
            </Link>
          </div>
          <div className="social_media ">
            <a href="https://www.instagram.com/mayawears.np/" target="_blank">
              <li>
                <svg
                  height="20px"
                  width="20px"
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 56.7 56.7"
                  enableBackground="new 0 0 56.7 56.7"
                  xmlSpace="preserve"
                >
                  <g>
                    <path
                      d="M28.2,16.7c-7,0-12.8,5.7-12.8,12.8s5.7,12.8,12.8,12.8S41,36.5,41,29.5S35.2,16.7,28.2,16.7z M28.2,37.7
                  c-4.5,0-8.2-3.7-8.2-8.2s3.7-8.2,8.2-8.2s8.2,3.7,8.2,8.2S32.7,37.7,28.2,37.7z"
                    />
                    <circle cx="41.5" cy="16.4" r="2.9" />
                    <path
                      d="M49,8.9c-2.6-2.7-6.3-4.1-10.5-4.1H17.9c-8.7,0-14.5,5.8-14.5,14.5v20.5c0,4.3,1.4,8,4.2,10.7c2.7,2.6,6.3,3.9,10.4,3.9
                      h20.4c4.3,0,7.9-1.4,10.5-3.9c2.7-2.6,4.1-6.3,4.1-10.6V19.3C53,15.1,51.6,11.5,49,8.9z M48.6,39.9c0,3.1-1.1,5.6-2.9,7.3
                      s-4.3,2.6-7.3,2.6H18c-3,0-5.5-0.9-7.3-2.6C8.9,45.4,8,42.9,8,39.8V19.3c0-3,0.9-5.5,2.7-7.3c1.7-1.7,4.3-2.6,7.3-2.6h20.6
                      c3,0,5.5,0.9,7.3,2.7c1.7,1.8,2.7,4.3,2.7,7.2V39.9L48.6,39.9z"
                    />
                  </g>
                </svg>
              </li>
            </a>
            <a href="https://www.facebook.com/mayawears.np" target="_blank">
              <li>
                <svg
                  height="20PX"
                  style={{
                    fillrule: "evenodd",
                    cliprule: "evenodd",
                    strokeLinejoin: "round",
                    strokeMiterlimit: 2,
                  }}
                  version="1.1"
                  viewBox="0 0 512 512"
                  width="20PX"
                  xmlSpace="preserve"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:serif="http://www.serif.com/"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <path d="M255.022,511.998l0.229,0.001l-0.079,0l-0.15,-0.001Zm1.806,0.001l-0.079,0l0.229,-0.001l-0.15,0.001Zm-2.588,-0.005l0.247,0.001l-0.142,0l-0.105,-0.001Zm3.415,0.001l-0.142,0l0.247,-0.001l-0.105,0.001Zm-4.169,-0.007l0.165,0.001l-0.132,-0.001l-0.033,0Zm4.995,0l-0.132,0.001l0.165,-0.001l-0.033,0Zm0.826,-0.009l-0.058,0.001l0.223,-0.003l-0.165,0.002Zm-6.779,-0.002l0.223,0.003l-0.058,-0.001l-0.165,-0.002Zm7.604,-0.01l-0.135,0.002l0.275,-0.004l-0.14,0.002Zm-8.404,-0.002l0.275,0.004l-0.135,-0.002l-0.14,-0.002Zm9.228,-0.012l-0.182,0.003l0.254,-0.005l-0.072,0.002Zm-9.984,-0.002l0.254,0.005l-0.182,-0.003l-0.072,-0.002Zm-0.937,-0.019l0.225,0.005l-0.04,-0.001l-0.185,-0.004Zm11.745,0.004l-0.04,0.001l0.225,-0.005l-0.185,0.004Zm-12.567,-0.025l0.309,0.008l-0.125,-0.003l-0.184,-0.005Zm13.39,0.005l-0.125,0.003l0.309,-0.008l-0.184,0.005Zm0.823,-0.022l-0.201,0.006l0.316,-0.009l-0.115,0.003Zm-14.967,-0.003l0.316,0.009l-0.201,-0.006l-0.115,-0.003Zm-0.72,-0.022l0.225,0.007l-0.212,-0.007l-0.194,-0.006l0.181,0.006Zm16.509,0l-0.212,0.007l0.225,-0.007l0.181,-0.006l-0.194,0.006Zm0.821,-0.027l-0.112,0.004l0.345,-0.012l-0.233,0.008Zm-18.371,-0.008l0.345,0.012l-0.112,-0.004l-0.233,-0.008Zm-0.749,-0.028l0.362,0.013l-0.201,-0.007l-0.161,-0.006Zm19.941,0.006l-0.201,0.007l0.362,-0.013l-0.161,0.006Zm-20.676,-0.036l0.354,0.015l-0.277,-0.011l-0.077,-0.004Zm21.495,0.004l-0.277,0.011l0.354,-0.015l-0.077,0.004Zm-22.525,-0.049l0.38,0.017l-0.093,-0.003l-0.287,-0.014Zm23.345,0.014l-0.093,0.003l0.38,-0.017l-0.287,0.014Zm-24.084,-0.048l0.394,0.018l-0.186,-0.008l-0.208,-0.01Zm24.902,0.01l-0.186,0.008l0.394,-0.018l-0.208,0.01Zm-25.63,-0.047l0.397,0.02l-0.279,-0.013l-0.118,-0.007Zm26.448,0.007l-0.279,0.013l0.397,-0.02l-0.118,0.007Zm0.818,-0.043l-0.362,0.019l0.321,-0.017l0.378,-0.021l-0.337,0.019Zm-27.925,0.002l0.321,0.017l-0.362,-0.019l-0.337,-0.019l0.378,0.021Zm28.741,-0.048l-0.16,0.009l0.406,-0.023l-0.246,0.014Zm-29.844,-0.014l0.406,0.023l-0.16,-0.009l-0.246,-0.014Zm-0.722,-0.043l0.405,0.024l-0.253,-0.014l-0.152,-0.01Zm31.382,0.01l-0.253,0.014l0.405,-0.024l-0.152,0.01Zm-32.071,-0.053l0.365,0.023l-0.34,-0.021l-0.342,-0.022l0.317,0.02Zm32.887,0.002l-0.34,0.021l0.365,-0.023l0.317,-0.02l-0.342,0.022Zm0.814,-0.053l-0.122,0.008l0.387,-0.026l-0.265,0.018Zm-34.755,-0.018l0.387,0.026l-0.122,-0.008l-0.265,-0.018Zm-0.721,-0.05l0.38,0.027l-0.208,-0.014l-0.172,-0.013Zm36.29,0.013l-0.208,0.014l0.38,-0.027l-0.172,0.013Zm-37.009,-0.064l0.349,0.025l-0.271,-0.019l-0.078,-0.006Zm37.822,0.006l-0.271,0.019l0.349,-0.025l-0.078,0.006Zm-38.789,-0.079l0.306,0.023l-0.074,-0.005l-0.232,-0.018Zm39.602,0.018l-0.074,0.005l0.306,-0.023l-0.232,0.018Zm0.811,-0.063l-0.146,0.011l0.311,-0.025l-0.165,0.014Zm-41.157,-0.014l0.311,0.025l-0.146,-0.011l-0.165,-0.014Zm-0.725,-0.059l0.264,0.022l-0.186,-0.015l-0.078,-0.007Zm42.694,0.007l-0.186,0.015l0.264,-0.022l-0.078,0.007Zm-43.492,-0.074l0.079,0.007l-0.013,-0.001l-0.066,-0.006Zm44.302,0.006l-0.013,0.001l0.079,-0.007l-0.066,0.006Zm0.81,-0.071l-0.072,0.006l0.181,-0.016l-0.109,0.01Zm-45.965,-0.01l0.181,0.016l-0.072,-0.006l-0.109,-0.01Zm-0.75,-0.068l0.135,0.013l-0.084,-0.008l-0.051,-0.005Zm47.523,0.005l-0.084,0.008l0.135,-0.013l-0.051,0.005Zm-63.736,-2.025c-122.319,-19.226 -216,-125.203 -216,-252.887c0,-141.29 114.71,-256 256,-256c141.29,0 256,114.71 256,256c0,127.684 -93.681,233.661 -216,252.887l0,-178.887l59.65,0l11.35,-74l-71,0l0,-48.021c0,-20.245 9.918,-39.979 41.719,-39.979l32.281,0l0,-63c0,0 -29.296,-5 -57.305,-5c-58.476,0 -96.695,35.44 -96.695,99.6l0,56.4l-65,0l0,74l65,0l0,178.887Z" />
                </svg>
              </li>
            </a>
            
            <a href="https://www.pinterest.com/mayawears/" target="_blank">
              <li>
                <svg
                  enableBackground="new 0 0 100 100"
                  height="28px"
                  version="1.1"
                  viewBox="0 0 100 100"
                  width="28px"
                  xmlSpace="preserve"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <g id="color_x5F_fill">
                    <path
                      d="M40.294,85.885c1.106-2.086,2.237-4.548,2.896-6.831c0.608-2.111,2.055-8.001,2.34-10.115   c2.143,4.371,7.407,4.889,11.848,4.643c6.618-0.366,13.398-5.242,16.019-11.226c2.362-5.395,4.064-11.963,3.477-17.878   c-0.453-4.562-2.69-10.157-6.039-13.439c-2.548-2.498-5.896-4.468-8.956-5.955c-3.818-1.855-9.06-2-13.133-1.656   c-2.486,0.21-4.827,0.575-7.215,1.403c-2.116,0.734-3.997,2.048-6.027,3.066c-1.906,0.956-3.552,1.896-4.913,3.369   c-1.456,1.576-2.901,3.477-4.209,5.159c-1.553,1.998-2.204,4.436-3.132,6.884c-0.825,2.178-0.988,4.984-0.618,7.375   c0.652,4.213,2.023,7.953,5.219,10.9c1.117,1.03,3.403,3.562,4.906,2.277c1.491-1.275,1.584-4.838,0.75-6.335   c-0.9-1.617-2.54-2.891-2.753-4.823c-0.624-5.656,1.153-11.761,4.777-16.143c5.999-7.253,18.488-8.484,25.97-2.913   c3.132,2.333,5.138,5.89,5.503,9.781c0.371,3.963,0.592,8.756-1.003,12.482c-1.044,2.44-2.482,4.927-4.077,7.051   c-1.633,2.176-4.394,3.659-7.116,3.676c-3.751,0.024-4.722-2.388-7.035-4.74c0.717-1.421,1.071-3.846,1.391-5.469   c0.452-2.3,1.075-4.163,1.868-6.341c1.109-3.044,1.686-7.69-1.305-9.86c-3.292-2.388-8.127,0.041-9.998,3.195   c-1.146,1.932-1.187,4.31-1.133,6.49c0.052,2.097,0.765,4.152,0.669,6.258c-0.093,2.042-0.973,3.952-1.282,5.959   c-0.373,2.42-0.756,4.741-1.393,7.11c-1.184,4.399-2.751,8.742-2.638,13.323c0.031,1.285,0.064,2.71-0.224,3.964   c-1.489,0.074-3.688-1.793-4.981-2.57c-2.197-1.32-3.482-2.698-5.212-4.532c-1.89-2.003-3.978-3.593-5.781-5.752   c-1.549-1.855-2.804-4.02-3.906-6.113c-5.168-9.804-4.717-22.094-1.182-32.453c1.909-5.593,6.486-10.235,10.31-14.623   c5.896-6.771,17.617-10.462,26.528-10.306c5.858,0.103,11.107,1.33,16.605,3.256c8.58,3.006,16.897,10.877,19.991,19.486   c1.471,4.093,3.276,8.167,3.779,12.527c0.478,4.136-0.403,8.273-1.001,12.35c-1.245,8.487-6.29,16.587-12.779,22.062   c-1.917,1.617-4,3.141-6.138,4.453c-7.396,4.537-15.667,5.645-24.151,5.502c-1.635-0.027-3.268-0.003-4.862-0.415   c-2.115-0.545-1.695-1.598-0.852-3.144C40.162,86.133,40.229,86.009,40.294,85.885z"
                      fill="#000"
                    />
                  </g>
                  <g id="offset_x5F_print_x5F_outline" />
                </svg>
              </li>
            </a>
            <a href="https://www.tiktok.com/@mayawears.np"target="_blank" >
              <li>
                <svg viewBox="0 0 448 512" height='20' width='20' xmlns="http://www.w3.org/2000/svg" strokeWidth='1'>
                  <path d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"/></svg>
              </li>
            </a>
          </div>
        </div>

        <div className="copyright">
          <p>
            © {new Date().getFullYear()} Maya Wears. All right reserved.
          </p>
          <p>Designed and Developed by <a href="https://bleedingtech.com.np" target="_blank"> Bleeding Tech</a></p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
